// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Avatar_wrapper__-JMq2","hide":"Avatar_hide__3Uy8P","initials":"Avatar_initials__GjZg4"};